'use es6';

import I18n from 'I18n';
import { Component } from 'react';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { APP_STATUS } from 'ContentEditorUI/redux/constants';
import { Flex } from 'foundations-components/components/Flex';

/**
 * @param {Object} props
 * @param {React.ReactNode} [props.children] (optional)
 * @param {string} props.appStatus (required)
 * @param {string} props.contentName (required)
 * @param {string} props.fullCategoryName (required)
 * @param {instanceOf(Date) | number } [props.lastSavedDate] (optional)
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ContentEditorComponent extends Component {
  componentDidMount() {
    this.setDocumentTitle();
  }
  componentDidUpdate(prevProps) {
    const {
      lastSavedDate
    } = this.props;
    if (lastSavedDate !== prevProps.lastSavedDate) {
      this.setDocumentTitle();
    }
    if (prevProps.contentName !== this.props.contentName) {
      this.setDocumentTitle();
    }
  }
  setDocumentTitle() {
    const {
      contentName,
      fullCategoryName
    } = this.props;
    document.title = I18n.text(`contentEditorUI.htmlTitle.${fullCategoryName}`, {
      name: I18n.SafeString(contentName.trim() || 'HubSpot')
    });
  }

  // For now, support existing code that triggers/dispatches "global" loading events/actions.
  // However, eventually I don't want us to displatch loading actions,
  // rather try making loading a function of other state.
  // For example, instead of `state.appStatus`, there would be `state.isShowingLoadingOverlay` which
  // would come from a reducer looking at actions like
  // STARTED_EXPENSIVE_THING and FINISHED_EXPENSIVE_THING
  // (rather than how we directly dispatch `SHOW_LOADING` and `HIDE_LOADING` actions now).
  renderGlobalLoadingOverlayIfNeeded() {
    const {
      appStatus
    } = this.props;
    return appStatus === APP_STATUS.LOADING ? /*#__PURE__*/_jsx(LoadingOverlay, {}) : null;
  }
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/_jsxs(Flex, {
      flexGrow: 1,
      "data-test-id": "content-editor-component",
      children: [this.renderGlobalLoadingOverlayIfNeeded(), children]
    });
  }
}